import * as React from "react";

const SvgCursorsDragRight = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      fillOpacity={0.92}
      fillRule="evenodd"
      d="M11.066 22v-7.507h1.298v4.832L20 11.985l-7.636-7.362v4.883h-1.299V2H6v20z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.618 21v-7.725h3.993v2.884L18 11.973l-4.39-4.15v2.902H9.619V3H7v18z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCursorsDragRight;
